import { useQuery } from "@tanstack/react-query";

import { api } from "@utils/api";

import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

import { DashboardQueryProps } from "@customTypes/dashboard";

import { dashboardQKeys } from "./queryKeys";


const select = (
  res: any
): {
  total: number;
  doctors: number;
  nurses: number;
  admins: number;
  receptionists: number;
} | null => {
  //   console.log(res.data.data);
  return res.data.data;
};

export const useGetTotalUsersByRole = ({
  dateRange,
  startDate,
  endDate,
}: DashboardQueryProps) => {
  const handleErrors = useQueryErrorHandling();

  return useQuery({
    queryKey: dashboardQKeys.totalUsersByRoleWithFilters({
      dateRange,
      startDate,
      endDate,
    }),
    queryFn: () => {
      return api.get("analytics/users/role-summary", {
        params: {
          range: dateRange?.replaceAll("-", "_"),
          ...(dateRange === "custom" && {
            start_date: startDate,
            end_date: endDate,
          }),
        },
      });
    },
    select,
    staleTime: 1000 * 60 * 5, // 5 minutes
    enabled:
      dateRange !== "custom" ||
      !!(dateRange === "custom" && startDate && endDate),

    onError: (res: any) => {
      console.error("[From Get Total users by role]", res);
      handleErrors(res, "query");
    },
  });
};
